import { FIND_COMPANY_FACTOR } from "../../routes";
import customAxios from "../../customAxios";
import { IFindCompanyFactor } from "../../../types/company.interface";

async function findCompanyFactor(props: IFindCompanyFactor) {
  const thisUrl = FIND_COMPANY_FACTOR;

  let body: any = {
    _id: props?.companyId,
    page: props?.page,
    limit: props?.limit,
    populate: "student",
  };

  // ?? Academic year (سال تحصیلی) scope
  if (props?.academicYear) body.academicYear = props.academicYear;

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ PAY_DEBT_TO_DRIVER: error });
  }
}

export default findCompanyFactor;
